/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { Module } from '@msdyn365-commerce-modules/utilities';
import { IDefaProductDetailsViewProps } from './defa-product-details';

export default (props: IDefaProductDetailsViewProps) => {
    return (
        <Module {...props.ModuleProps}>
            {props.sections}
        </Module>
    );
};
